import { gridSizeMdLg12 } from "@/shared"
import { Grid, Typography } from "@mui/material"

interface InformeSolucion {
    fecha: string;
    descripcion: string;
    usuario: string;
    razon_social: string;
    departamento: string;
}
type Props = {
    informe_solucion: InformeSolucion[]
}

const HistorialInformeSolucion = ({
    informe_solucion
}: Props) => {
    return (
        <>
            {
                informe_solucion && informe_solucion.length > 0?
                (<Grid container item {...gridSizeMdLg12} spacing={2}>
                    <Grid item {...gridSizeMdLg12}>
                        <Typography variant="h6">Historial de Informe de Solución</Typography>
                    </Grid>
                    <Grid item {...gridSizeMdLg12} height={400} 
                    sx={{overflowY: 'scroll', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', borderRadius: 2, marginLeft: 2, marginY: 2}}>
                        {
                            informe_solucion.map((item: any, index: number) => (
                                <Grid container item {...gridSizeMdLg12} key={index} sx={{ border: '1px solid #ccc', padding: '10px', borderRadius:2, marginBottom: '10px' }}>
                                    <Grid container item {...gridSizeMdLg12}>
                                        <Typography variant="caption">{item.razon_social||"RAZON SOCIAL"}</Typography>
                                        <Typography variant="caption">-{item.usuario||"USUARIO"}-</Typography>
                                        <Typography variant="caption">{item.departamento||"DEPARTAMENTO"}</Typography>
                                    </Grid>
                                    <Grid item {...gridSizeMdLg12}>
                                    <Typography variant="body1">{item.descripcion||"DESCRIPCION"}</Typography>
                                    </Grid>
                                    <Grid item {...gridSizeMdLg12}>
                                    <Typography variant="caption">{item.fecha||"FECHA"}</Typography>
                                    </Grid>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>)
                :null
            }
        </>
    )
}

export default HistorialInformeSolucion